'use client';
import { Faq, FaqCategory } from '@/lib/types/faqs.ts';
import * as S from './styles.ts';
import { Breadcrumbs, H4, P } from '@template/components';
import { FaqMenu } from './Menu';
import { Questions } from './Questions';
import { htmlToReactComponents } from '@/lib/utils/html.ts';
import { Search } from './Search';
import { Webinar } from './Webinar';
import { Vote } from './Vote';
import Home from '@template/icons/Home.tsx';

interface IFaqBrowsingSectionProps {
  categories: FaqCategory[];
  categoryUrlKey: string;
  faq?: Faq;
  faqKey?: string;
}

const FaqBrowsingSectionComponent = ({
  categories,
  categoryUrlKey,
  faq,
  faqKey,
}: IFaqBrowsingSectionProps) => {
  const currentCategory = categories.find(
    (category) => category.url_key === categoryUrlKey
  );
  const faqsTitle =
    currentCategory?.category_url_key === 'all'
      ? 'Frequently Asked Questions'
      : `${currentCategory?.category_name} FAQs`;

  const isFaqAnswerPage = !!faq;
  return (
    <S.FaqBrowsingSectionWrapper>
      {isFaqAnswerPage ? (
        <Breadcrumbs
          breadcrumbs={[
            {
              label: 'Back to FAQs',
              url: '/faq',
              icon: <Home />,
              title: 'View All Frequently Asked Questions',
            },
            {
              label: faq.categoryName,
              url: `/faq/${faq.categoryUrlKey}`,
              ellipsis: true,
              title: `View ${faq.categoryName} Questions`,
            },
            { label: faq.title },
          ]}
          component={<Search mini={true} />}
        />
      ) : (
        <Search />
      )}

      <S.FaqBrowsingSectionContainer $withBreadcrumbs={isFaqAnswerPage}>
        <S.MenuContainer $mobileVisible={!isFaqAnswerPage}>
          <FaqMenu categories={categories} categoryUrlKey={categoryUrlKey} />
        </S.MenuContainer>
        {isFaqAnswerPage ? (
          <S.QuestionContainer>
            <S.Title>
              <P>{faq.categoryName}</P>
              <H4>{faq.title}</H4>
            </S.Title>
            <S.QuestionContent>
              {htmlToReactComponents(faq.content)}
            </S.QuestionContent>
            <Vote id={faq.id} voteValue={faq.userVoteValue} />
            {/* Once CMS is available, render Webinar conditionally based on whether we're on Yay site */}
            <Webinar />
          </S.QuestionContainer>
        ) : (
          <Questions faqsTitle={faqsTitle} currentCategory={currentCategory} />
        )}
      </S.FaqBrowsingSectionContainer>
    </S.FaqBrowsingSectionWrapper>
  );
};

export default FaqBrowsingSectionComponent;
export const options = [
  {
    description: '',
    displayName: 'FaqBrowsingSectionComponent',
    methods: [],
    props: {
      categories: {
        required: true,
        flowType: {
          name: 'Array',
          elements: [{ name: 'FaqCategory' }],
          raw: 'FaqCategory[]',
        },
        description: '',
      },
      categoryUrlKey: {
        required: true,
        flowType: { name: 'string' },
        description: '',
      },
      faq: {
        required: false,
        flowType: { name: 'Faq' },
        description: '',
      },
      faqKey: {
        required: false,
        flowType: { name: 'string' },
        description: '',
      },
    },
  },
];
